<template>
  <div :class="$style.box">
    <div :class="$style.content" :style="{ height: dialogHeight, marginTop: dialogMarginTop }">
      <div :class="$style.title">
        <slot name="title"></slot>
      </div>
      <div :class="$style.main">
        <slot name="main-content"></slot>
      </div>
      <div :class="$style.footer">
        <slot name="footer"></slot>
      </div>
    </div>
    <i class="iconfont yw-close" style="margin-top: 50px" @click="handleClose"></i>
  </div>
</template>

<script>
export default {
  props: {
    dialogType: {
      type: String,
      default: '',
    },
    dialogHeight: {
      type: String,
      default: 'auto',
    },
    dialogMarginTop: {
      type: String,
      default: '35%',
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit('closeDialog');
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  position: fixed;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.65);
  .content {
    position: relative;
    padding: 30px;
    margin: auto;
    width: 93%;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .title {
      text-align: center;
      color: '#000000';
    }
    .main {
    }
    .footer {
      @include vertical-center;
      margin-top: 30px;
    }
  }
  :global {
    .yw-close {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      color: #ffffff;
      font-size: 50px;
      z-index: 1;
      margin: auto;
      font-weight: 100;
    }
  }
}
</style>
